/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1XIcon24Solid = forwardRef('People1XIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18 7A6 6 0 1 1 6 7a6 6 0 0 1 12 0Z" }),
        React.createElement("path", { d: "M13.322 14.032A24.82 24.82 0 0 0 12 14c-2.985 0-8.736.395-9.821 6.01C1.969 21.093 2.895 22 4 22h9.036a3.495 3.495 0 0 1 .99-2.975l.524-.525-.525-.525a3.501 3.501 0 0 1-.704-3.943Z" }),
        React.createElement("path", { d: "M17.384 14.616a1.25 1.25 0 0 0-1.768 1.768l2.116 2.116-2.116 2.116a1.25 1.25 0 0 0 1.768 1.768l2.116-2.116 2.116 2.116a1.25 1.25 0 0 0 1.768-1.768L21.268 18.5l2.116-2.116a1.25 1.25 0 0 0-1.768-1.768L19.5 16.732l-2.116-2.116Z" })));
});
